import { render, staticRenderFns } from "./Nominate.vue?vue&type=template&id=34c3e98f&scoped=true&"
import script from "./Nominate.vue?vue&type=script&lang=js&"
export * from "./Nominate.vue?vue&type=script&lang=js&"
import style0 from "./Nominate.vue?vue&type=style&index=0&id=34c3e98f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c3e98f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
